import { Link } from "react-router-dom";
const AccountingReportTabs = (props) => {
  return (
    <ul
      className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"
      role="tablist"
    >
      <li className="nav-item" role="presentation">
        <Link
          to={"/journalreports"}
          className={
            props.pageName === "JOURNALREPORT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          Journal REPORT
        </Link>
      </li>
      {/* <li className="nav-item" role="presentation">
        <Link
          to={"/ledgerreports"}
          className={
            props.pageName === "LEDGERREPORT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          LEDGER REPORT
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/trialbalancereports"}
          className={
            props.pageName === "TRIALBALANCEREPORT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          Trial Balance REPORT
        </Link>
      </li> */}

      <li className="nav-item" role="presentation">
        <Link
          to={"/profitlossreports"}
          className={
            props.pageName === "PROFITLOSSREPORT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          PROFITLOSS REPORT
        </Link>
      </li>
    </ul>
  );
};

export default AccountingReportTabs;
